import { render, staticRenderFns } from "./data-user.vue?vue&type=template&id=327fa635&"
import script from "./data-user.component.ts?vue&type=script&lang=ts&"
export * from "./data-user.component.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports